import type { SimplifiedPromotion } from 'typings'
import { getStatusInfo } from '../status'

const STATUS_ORDER = {
  running: 0,
  scheduled: 1,
  paused: 2,
  completed: 3,
}

export function sortByName(a: SimplifiedPromotion, b: SimplifiedPromotion) {
  return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase())
}
export function sortByStatus(a: SimplifiedPromotion, b: SimplifiedPromotion) {
  return (
    STATUS_ORDER[getStatusInfo(a).id] - STATUS_ORDER[getStatusInfo(b).id] ||
    sortByName(a, b)
  )
}

export function sortByBeginDate(
  a: SimplifiedPromotion,
  b: SimplifiedPromotion
) {
  return (
    new Date(a.beginDate).getTime() - new Date(b.beginDate).getTime() ||
    sortByName(a, b)
  )
}

export function sortByEndDate(a: SimplifiedPromotion, b: SimplifiedPromotion) {
  const aValue = a.endDate
    ? new Date(a.endDate).getTime()
    : Number.MAX_SAFE_INTEGER

  const bValue = b.endDate
    ? new Date(b.endDate).getTime()
    : Number.MAX_SAFE_INTEGER

  return aValue - bValue || sortByName(a, b)
}
